import CheckCircleIcon from "@mui/icons-material/CheckCircle";
const { styled } = require("@mui/material");

const CCircleCheckbox = styled(CheckCircleIcon)(({ theme }) => ({ "&.MuiSvgIcon-root": { color: theme.palette.common.orange } }));
export default CCircleCheckbox;
